import guideimg from "../images/guide.png";

export default function Guide(props) {

  return (
    <div>
        <img src={guideimg} alt="guide" width="100%"/>
    </div>
  )
};